import { defineComponent, h } from 'vue';
import MenuIcon from './MenuIcon.vue';

// Component exports preserve the sidebar and TabsBar's dynamic icon API.
const menuIcon = name => defineComponent({
	name: `MenuIcon-${name}`,
	setup: () => () => h(MenuIcon, { name }),
});

export const CalendarIcon = menuIcon('calendar');
export const BasketIcon = menuIcon('basket');
export const InvoiceUpIcon = menuIcon('invoice-up');
export const InvoiceDownIcon = menuIcon('invoice-down');
export const DocumentIcon = menuIcon('document');
export const ChartIcon = menuIcon('chart');
export const FolderIcon = menuIcon('folder');
export const ChevronLeftIcon = menuIcon('chevron-left');
export const SettingsIcon = menuIcon('settings');
export const ExitIcon = menuIcon('exit');
